import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material'

interface StyledToggleButtonGroupProps<T extends string> extends Omit<ToggleButtonGroupProps, 'onChange' | 'value'> {
  value: T
  onChange: (value: T) => void
  options: { value: T; label: string }[]
}

function StyledToggleButtonGroup<T extends string>({ value, onChange, options, ...rest }: StyledToggleButtonGroupProps<T>) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      onChange={(_, v) => { if (v) onChange(v as T) }}
      sx={{
        backgroundColor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        '& .MuiToggleButtonGroup-grouped': {
          border: 'none',
          borderRadius: '0 !important',
          '&:first-of-type': { borderRadius: '7px 0 0 7px !important' },
          '&:last-of-type': { borderRadius: '0 7px 7px 0 !important' },
          '&:not(:last-of-type)': { borderRight: 1, borderColor: 'divider' },
        },
        '& .MuiToggleButton-root': {
          color: 'text.secondary',
          '&.Mui-selected': { color: 'text.primary', backgroundColor: 'action.selected' },
        },
      }}
      {...rest}
    >
      {options.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value}>{opt.label}</ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default StyledToggleButtonGroup
